import { Icon } from '@iconify/react';
import { Tabs, TabsList, TabsTrigger } from '@/components/shadcn/tabs';

export type BadmintonStatistikTab = 'games' | 'standings' | 'mmr';

interface BadmintonStatistikTabsProps {
  tab: BadmintonStatistikTab;
  onTabChange: (tab: BadmintonStatistikTab) => void;
}

const TABS: { id: BadmintonStatistikTab; label: string; icon: string }[] = [
  { id: 'games', label: 'Pertandingan', icon: 'mdi:badminton' },
  { id: 'standings', label: 'Klasemen', icon: 'mdi:format-list-numbered' },
  // { id: 'mmr', label: 'Top MMR', icon: 'mdi:trending-up' },
];

export default function BadmintonStatistikTabs({ tab, onTabChange }: BadmintonStatistikTabsProps) {
  return (
    <Tabs value={tab} onValueChange={(value) => onTabChange(value as BadmintonStatistikTab)}>
      <TabsList className="h-auto w-full justify-start gap-2 overflow-x-auto bg-transparent p-0">
        {TABS.map((item) => (
          <TabsTrigger
            key={item.id}
            value={item.id}
            className="rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-400 shadow-none data-[state=active]:border-[#FC480D] data-[state=active]:bg-white data-[state=active]:text-[#FC480D] data-[state=active]:shadow-none"
          >
            <Icon icon={item.icon} className="h-4 w-4" />
            {item.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
